export type ThemeMode = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

export interface ThemeConfig {
  mode: ThemeMode;
  resolvedTheme: ResolvedTheme;
  systemTheme: ResolvedTheme;
  setTheme: (theme: ThemeMode) => void;
  toggleTheme: () => void;
  themes: string[];
  currentTheme: string;
  setCurrentTheme: (theme: string) => void;
}

export const THEME_STORAGE_KEY = "terramatrix-theme-mode";
export const THEME_VARIANT_STORAGE_KEY = "terramatrix-theme-variant";
